<template>
  <div class="wrapper">
    <van-search
      v-model="value"
      shape="round"
      background="#F8F8F8"
      placeholder="搜索科室"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon">
      </template>
    </van-search>
    <div class="cate_content" v-if="showIf">
      <ul class="list_index">
        <li v-for="it in list.floors" :key="it" @click="handleTab(it)" :class="current == it?`list_xuan`:` `">
          <svg :class="current == it?`selectTriangle`:`hide`" width="14" height="14" viewBox="-50 -50 300 300">
            <polygon class="triangle" stroke-linejoin="round" points="200 100 0 200 0 0"/>
          </svg>{{it}}F
        </li>
      </ul>
      <ul class="list_content" v-if="ksLists.length == 0?false:true">
        <li v-for="(item,index) in ksLists" :key="index">{{item.deptName}}</li>
      </ul>
      <div class="list_content" v-if="ksLists.length == 0?true:false">
        <span class="nothing">此楼层暂无开放的科室</span>
      </div>
    </div>
    <ul class="query_content" v-if="!showIf">
      <li v-for="(item,index) in searchList" :key="index" @click="handleTab(item.flowNo)">{{item.deptName}}</li>
    </ul>
  </div>
</template>

<script>
import { GetRequest } from "@/tool/parameter.js"
export default {
  data(){
      return{
        current: 1,
        value: "",
        showIf: true,
        list: [],
        ksLists: [],
        searchList: []
      }
  },
  created() {
    this.list = JSON.parse(sessionStorage.getItem("BuildingInformation"));
    document.title = this.list.buildingName+"楼层科室分布";
    let ary = [];
    for(let i=1;i<=this.list.floors;i++){
      ary.push(i)
    }
    this.list.floors = ary;
    console.log(this.list)
  },
  methods:{
    handleTab(value){
      this.current = value;
      this.ksLists = this.list.bbuildinginfodels.filter(item => {
        return item.flowNo == value
      })
      this.value = ""
      this.showIf = true
    },
    handleQuery() {
      if (this.value) {
        this.showIf = false;
      } else {
        this.showIf = true;
      }
      this.searchList = this.list.bbuildinginfodels.filter(item => {
        return item.deptName.indexOf(this.value) != -1
      })
    },
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  background-color: #F8F8F8;
  >img{
    width: 100%;
    margin: 30px 0;
  }
  /deep/ .van-search__content{
    background-color: #E4E4E4;
  }
  .triangle {
    fill: #1C96CB;
    stroke: #1C96CB;
    stroke-width: 100;
  }
  .ss_icon{
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .cate_content{
    width: 375px;
    flex-grow: 1;
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    overflow: hidden;
    border: 1px solid rgb(233, 233, 233);
    .list_index{
      border-right: 1px solid rgb(233, 233, 233);
      overflow-y: scroll;
      width: 118px;
      height: 100%;
      background-color: #F8F8F8;
      >li{
        border-bottom: 1px solid rgb(233, 233, 233);
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        box-sizing: border-box;
        position: relative;
        height: 45px;
        color: black;
        font-size: 18px;
        font-weight: 400;
        text-align: center;
        .selectTriangle{
          display: block;
          position: absolute;
          top: calc(50% - 7px);
          right: 10px;
        }
        .hide{
          display: none;
        }
      }
      .list_xuan{
        background: #fff;
        color: #1C96CB;
        font-weight: 700;
      }
    }
    .list_content{
      position: relative;
      flex-grow: 1;
      height: 100%;
      background: #fff;
      display: flex;
      flex-flow: column nowrap;
      overflow-y: scroll;
      // margin-right: 10px;
      >li{
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        height: 45px;
        line-height: 45px;
        box-sizing: border-box;
        padding: 0px 30px;
        font-size: 16px;
        font-weight: 700;
        border-bottom: 1px solid rgb(233, 233, 233);
      }
      .nothing{
        font-size: 20px;
        font-weight: bold;
        margin-top: 120px;
        text-align: center;
      }
    }
  }
  .query_content{
    display: flex;
    flex-flow: column nowrap;
    background: #fff;
    >li{
      padding: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/HospitalNavigation/BuildingInformation.vue